export default __webpack_public_path__ + "static/media/4_sugarcrm.f8f45130.svg";